/* tslint:disable */
/* eslint-disable */
/**
 * FancyAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the GetElaReadingLevelsR200ResponseInnerCurrentExtra interface.
 */
export function instanceOfGetElaReadingLevelsR200ResponseInnerCurrentExtra(value) {
    if (!('fastBridgeScore' in value) || value['fastBridgeScore'] === undefined)
        return false;
    if (!('starReadingScore' in value) || value['starReadingScore'] === undefined)
        return false;
    return true;
}
export function GetElaReadingLevelsR200ResponseInnerCurrentExtraFromJSON(json) {
    return GetElaReadingLevelsR200ResponseInnerCurrentExtraFromJSONTyped(json, false);
}
export function GetElaReadingLevelsR200ResponseInnerCurrentExtraFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return Object.assign(Object.assign({}, json), { 'fastBridgeScore': json['fast_bridge_score'], 'starReadingScore': json['star_reading_score'] });
}
export function GetElaReadingLevelsR200ResponseInnerCurrentExtraToJSON(value) {
    if (value == null) {
        return value;
    }
    return Object.assign(Object.assign({}, value), { 'fast_bridge_score': value['fastBridgeScore'], 'star_reading_score': value['starReadingScore'] });
}
